import { faMoneyBillTransfer } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ActionDialog from "components/reusable/ActionDialog";
import Toolbar from "components/Toolbar";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

function AddMoney() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [showPostaShqiptareAlertDialog, setShowPostaShqiptareAlertDialog] = useState(false);

  const transferOptions = [
    {
      title: t("MY_CARDS"),
      icon: faMoneyBillTransfer,
      action: () => {
        navigate("/add-money/my-cards");
      },
    },
    {
      title: t("ALBANIAN_POST"),
      icon: "images/posta_shqiptare_logo.png",
      customIcon: true,
      action: () => {
        setShowPostaShqiptareAlertDialog(true);
      },
    },
  ];

  return (
    <>
      <Toolbar title={t("O_ADD_MONEY")} showBackBtn={true} />
      <div>
        <div className="flex w-full justify-center">
          <div className="container grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-5 mx-7">
            {transferOptions.map((it) => (
              <div className="col-span-1 bg-card text-white p-4 flex flex-col items-center justify-center cursor-pointer h-[10rem]" onClick={it.action}>
                {it.customIcon ? <img src={it.icon} className="w-12 h-12" alt="" /> : <FontAwesomeIcon icon={it.icon} className="card-icon pt-5" size={"2xl"} />}
                <h4 className="font-medium pb-5 pt-2">{it.title}</h4>
              </div>
            ))}
          </div>
        </div>
      </div>
      {showPostaShqiptareAlertDialog && (
        <ActionDialog open={showPostaShqiptareAlertDialog} title={t("ALBANIAN_POST")} onClose={() => {setShowPostaShqiptareAlertDialog(false)}}>
          <div className="font-medium flex justify-center items-center text-center p-4">{t("ALBANIAN_POST_INSERT_INFO")}</div>
        </ActionDialog>
      )}
    </>
  );
}

export default AddMoney;
